import { useState, useCallback } from "react";
import { getIntegrationFields } from "../onboarding/services/onboardingApiService";

export const useIntegrationFields = () => {
  const [integrationFields, setIntegrationFields] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchFields = useCallback(async (systemId) => {
    if (!systemId) {
      setIntegrationFields({});
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await getIntegrationFields(systemId);
      setIntegrationFields(response.data || {});
    } catch (error) {
      if (error.status === 404) {
        setIntegrationFields({
          information: {
            type: "information",
          },
          noconnect: {
            type: "noconnect",
          },
        });
      } else {
        console.error("Failed to fetch integration fields:", error);
        setError("Kunne ikke laste integrasjonsfelt. Prøv igjen senere.");
        setIntegrationFields({});
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const clearFields = useCallback(() => {
    setIntegrationFields({});
    setError(null);
    setLoading(false);
  }, []);

  return {
    integrationFields,
    loading,
    error,
    fetchFields,
    clearFields,
  };
};
